/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: "/",
    name: "الطلاب",
    slug: "studets",
    icon: "UserIcon",
  },
  {
    url: "/paragraph",
    name: "المقالات",
    slug: "paragraph",
    icon: "BookIcon",
  },
  {
    url: "/active-users",
    name: "قائمة الشرف",
    slug: "active-users",
    icon: "UserIcon",
  },
  {
    url: null,
    name: "إعدادات الموقع",
    icon: "SettingsIcon",
    submenu: [
      {
        url:'/level',
        name: 'المستويات',
        slug: 'level',
      },
      // {
      //   url:'/story',
      //   name: 'القصص',
      //   slug: 'story',
      // },
      {
        url:'/topic',
        name: 'المواضيع',
        slug: 'topic',
      },
    ]
  },
]
